<template>
  <div class="fill-height col-12 ma-0 pa-2">
    <div class="px-2 mb-6" v-if="mode !== 'widget'">
      <v-divider></v-divider>
    </div>
    
    <!-- DETAILS/WIDGET MODE -->
    <v-card
        height="100%"
        class="rounded-lg"
        :color="mode === 'widget' ? '' : 'transparent'"
        :tile="mode !== 'widget'"
        :flat="mode !== 'widget'"
    >
<!--      <v-card-title v-if="mode === 'widget'" class="black&#45;&#45;text"><strong>{{ challengeTitle }}</strong></v-card-title>-->
      <div class="px-4" v-if="mode !== 'widget'">
        <v-tabs
            grow
        >
          <v-tab @click.prevent="setView('teams')">
            {{ $t('unbox.leaderboard') }} : {{ $t('unbox.teams') }}
          </v-tab>
          <v-tab @click.prevent="setView('organisations')">
            {{ $t('unbox.leaderboard') }} : {{ $t('unbox.organisations') }}
          </v-tab>
        </v-tabs>
      </div>
      <div class="px-4" v-if="mode === 'widget'">
        <v-tabs
            grow
        >
          <v-tab @click.prevent="setView('teams')">
            {{ challengeTitle }}: {{ $t('unbox.topTeams') }}
          </v-tab>
          <v-tab @click.prevent="setView('organisations')">
            {{ challengeTitle }}: {{ $t('unbox.topOrganisations') }}
          </v-tab>
        </v-tabs>
      </div>

      <v-card-text v-if="isLoading" class="d-flex justify-center">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-card-text>
      
      <!-- DEPARTMENT RANKING -->
      <v-card-text v-if="!isLoading && view === 'teams'" class="fill-height">
          <template v-for="(item) in departmentRanking">
            <div
                :key="item.identifier"
                class="d-flex flex-nowrap align-center"
            >
              <div class="col-1 pa-1 d-flex justify-center align-center">
                 <h2>{{ item.ranking }}</h2>
              </div>
              <div class="col-11 pa-1 d-flex justify-center align-center">
                <v-progress-linear
                    :color="item.myTeam ? '#5ABCB0' : '#B3D0CC'"
                    height="60"
                    rounded
                    class="rounded-pill d-flex flex-nowrap"
                    :value="(item.averagePerParticipant / dptMax) * 100"
                >
                  <div class="col-1 ma-0 pa-0">
                    <v-avatar color="primary" size="60">
                      <!--<v-img :src="item.avatar"></v-img>-->
                      <span class="white--text">{{ item.departmentName }}</span>
                    </v-avatar>
                  </div>
                  <div class="col-5 ma-0 px-6">
                    <div><strong>{{ $t('unbox.team') }}: {{ item.departmentName }}</strong></div>
                    <div>{{ $t('unbox.participants') }}: {{ item.dptParAmount }}</div>
                  </div>
                  <div class="col-6 ma-0 px-6">
                    {{ $t('unbox.avgRubPerPar', { amount: item.averagePerParticipant}) }}
                  </div>
                </v-progress-linear>
              </div>
            </div>
          </template>
      </v-card-text>

      <!-- ORGANISATION RANKING -->
      <v-card-text v-if="!isLoading && view === 'organisations'" class="fill-height">
        <template v-for="(item) in organisationRanking">
          <div
              :key="item.identifier"
              class="d-flex flex-nowrap align-center"
          >
            <div class="col-1 pa-1 d-flex justify-center align-center">
              <h2>{{ item.ranking }}</h2>
            </div>
            <div class="col-11 pa-1 d-flex justify-center align-center">
              <v-progress-linear
                  :color="item.myTeam ? '#5ABCB0' : '#B3D0CC'"
                  height="60"
                  rounded
                  class="rounded-pill d-flex flex-nowrap"
                  :value="(item.averagePerParticipant / orgMax) * 100"
              >
                <div class="col-1 ma-0 pa-0">
                  <v-avatar :color="item.organisationLogo ? 'white' : 'primary'" size="60">
                    <v-img v-if="item.organisationLogo" :src="item.organisationLogo" width="60" height="60"></v-img>
                    <span v-else class="white--text">{{ item.organisationName }}</span>
                  </v-avatar>
                </div>
                <div class="col-5 ma-0 px-6">
                  <div><strong>{{ item.organisationName }}</strong></div>
                  <div>{{ $t('unbox.participants') }}: {{ item.orgParAmount }}</div>
                </div>
                <div class="col-6 ma-0 px-6">
                  {{ $t('unbox.avgRubPerPar', { amount: item.averagePerParticipant}) }}
                </div>
              </v-progress-linear>
            </div>
          </div>
        </template>
      </v-card-text>

      <v-card-actions class="justify-end pt-0" v-if="!isLoading && mode === 'widget'">
        <v-btn text color="primary" @click.prevent="navigate('/challenges/' + challengeId)">
          {{ $t('unbox.showFullLeaderboard') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- OLDWIDGET MODE -->
    <v-card
        height="100%"
        class="rounded-lg"
        v-if="mode === 'oldwidget'"
    >
      <v-card-text v-if="isLoading" class="d-flex justify-center">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-card-text>
      
      <v-card-text v-if="!isLoading" class="fill-height d-flex flex-wrap pb-0">
        <!-- DEPARTMENT RANKING -->
        <div class="fill-height col-12 col-xl-6">
          <div class="d-flex justify-center align-center mb-3">
            <h2 class="black--text">{{ challengeTitle }}: {{ $t('unbox.topTeams') }}</h2>
          </div>
          <template v-for="(item) in departmentRanking">
            <div
                :key="item.identifier"
                class="d-flex flex-nowrap align-center"
            >
              <div class="col-1 pa-1 d-flex justify-center align-center">
                <h2>{{ item.ranking }}</h2>
              </div>
              <div class="col-11 pa-1 d-flex justify-center align-center">
                <v-progress-linear
                    :color="item.myTeam ? '#5ABCB0' : '#B3D0CC'"
                    height="60"
                    rounded
                    class="rounded-pill d-flex flex-nowrap"
                    :value="(item.averagePerParticipant / dptMax) * 100"
                >
                  <div class="col-1 ma-0 pa-0">
                    <v-avatar color="primary" size="60">
                      <!--<v-img :src="item.avatar"></v-img>-->
                      <span class="white--text">{{ item.departmentName }}</span>
                    </v-avatar>
                  </div>
                  <div class="col-5 ma-0 px-6">
                    <div><strong>{{ $t('unbox.team') }}: {{ item.departmentName }}</strong></div>
                    <div>{{ $t('unbox.participants') }}: {{ item.dptParAmount }}</div>
                  </div>
                  <div class="col-6 ma-0 px-6">
                    {{ $t('unbox.avgRubPerPar', { amount: item.averagePerParticipant}) }}
                  </div>
                </v-progress-linear>
              </div>
            </div>
          </template>
        </div>

        <!-- ORGANISATION RANKING -->
        <div class="fill-height col-12 col-xl-6">
          <div class="d-flex justify-center align-center mb-3">
            <h2 class="black--text">{{ challengeTitle }}: {{ $t('unbox.topOrganisations') }}</h2>
          </div>
          <template v-for="(item) in organisationRanking">
            <div
                :key="item.identifier"
                class="d-flex flex-nowrap align-center"
            >
              <div class="col-1 pa-1 d-flex justify-center align-center">
                <h2>{{ item.ranking }}</h2>
              </div>
              <div class="col-11 pa-1 d-flex justify-center align-center">
                <v-progress-linear
                    :color="item.myTeam ? '#5ABCB0' : '#B3D0CC'"
                    height="60"
                    rounded
                    class="rounded-pill d-flex flex-nowrap"
                    :value="(item.averagePerParticipant / orgMax) * 100"
                >
                  <div class="col-1 ma-0 pa-0">
                    <v-avatar :color="item.organisationLogo ? 'white' : 'primary'" size="60">
                      <v-img v-if="item.organisationLogo" :src="item.organisationLogo" width="60" height="60"></v-img>
                      <span v-else class="white--text">{{ item.organisationName }}</span>
                    </v-avatar>
                  </div>
                  <div class="col-5 ma-0 px-6">
                    <div><strong>{{ item.organisationName }}</strong></div>
                    <div>{{ $t('unbox.participants') }}: {{ item.orgParAmount }}</div>
                  </div>
                  <div class="col-6 ma-0 px-6">
                    {{ $t('unbox.avgRubPerPar', { amount: item.averagePerParticipant}) }}
                  </div>
                </v-progress-linear>
              </div>
            </div>
          </template>
        </div>
      </v-card-text>
      
      <v-card-actions class="justify-end pt-0" v-if="!isLoading">
        <v-btn text color="primary" @click.prevent="navigate('/challenges/' + challengeId)">
          {{ $t('unbox.showFullLeaderboard') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-unbox-challenge-widget-one",
  props: ['mode', 'challengeTitle', 'challengeId'],
  data() {
    return {
      isLoading: false,
      departmentRanking: [],
      dptMax: 1,
      orgMax: 1,
      organisationRanking: [],
      view: 'teams'
    }
  },

  mounted(){
    this.fetchUnbox()
  },

  methods: {
    async fetchUnbox(){
      this.isLoading = true
      let unboxData = {}
      unboxData = await api.unbox.getData().then((res) => { return res.data })
      
      if (unboxData.dptData && unboxData.dptData.length){
        unboxData.dptData.forEach((dpt) => {
          if (dpt.dptParAmount){
            dpt.averagePerParticipant = Math.round(dpt.dptRubAmount / dpt.dptParAmount)
            if (dpt.averagePerParticipant > this.dptMax){ this.dptMax = dpt.averagePerParticipant }
          }
        })
        this.departmentRanking = unboxData.dptData.sort((a, b) => { return b.averagePerParticipant - a.averagePerParticipant })
        this.departmentRanking.forEach((ranking, index) => {
          ranking.ranking = index + 1
        })
        if (this.mode === 'widget'){
          let myTeam = this.departmentRanking.find((x) => { return x.myTeam })
          if (myTeam && myTeam.ranking && myTeam.ranking > 4){
            this.departmentRanking = this.departmentRanking.slice(0,3)
            this.departmentRanking.push(myTeam)
          } else {
            this.departmentRanking = this.departmentRanking.slice(0,4)
          }
        }
      }

      if (unboxData.orgData && unboxData.orgData.length){
        for (const org of unboxData.orgData) {
          let image = await this.fetchImage(org.organisationLogoId)
          org.organisationLogo = image 
          if (org.orgParAmount){
            org.averagePerParticipant = Math.round(org.orgRubAmount / org.orgParAmount)
            if (org.averagePerParticipant > this.orgMax){ this.orgMax = org.averagePerParticipant }
          }
        }
        this.organisationRanking = unboxData.orgData.sort((a, b) => { return b.averagePerParticipant - a.averagePerParticipant })
        this.organisationRanking.forEach((ranking, index) => {
          ranking.ranking = index + 1
        })
        if (this.mode === 'widget'){
          let myTeam = this.organisationRanking.find((x) => { return x.myTeam })
          if (myTeam && myTeam.ranking && myTeam.ranking > 4){
            this.organisationRanking = this.organisationRanking.slice(0,3)
            this.organisationRanking.push(myTeam)
          } else {
            this.organisationRanking = this.organisationRanking.slice(0,4)
          }
        }
      }
      
      this.isLoading = false
    },

    async fetchImage(id){
      if (id){
        return await api.unbox.getSas(id)
            .then((res) => {
              return res.data
            })
            .catch(() => {
              return ''
            })
      } else {
        return ''
      }
    },

    setView(view) {
      this.view = view
    },

    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
  }
}
</script>

<style scoped>

</style>
